import React from 'react';
import { ajaxPost, AjaxResponseType } from '../../common/form/FrekulForm';

export const defaultKaraokeModificationClient = {
  validateKaraokeModification(karaokeOrderId: number, formData: {
    reason: string,
    correction: string,
    modification_item1: string,
    modification_details1: string,
    modification_item2: string,
    modification_details2: string,
    modification_item3: string,
    modification_details3: string,
    remake_url: string,
  }): Promise<AjaxResponseType> {
    return ajaxPost(`/karaoke_modification/ajax_validate_karaoke_modification/${karaokeOrderId}`, formData, {}, true);
  },
  executeKaraokeModification(karaokeOrderId: number, formData: {
    reason: string,
    correction: string,
    modification_item1: string,
    modification_details1: string,
    modification_item2: string,
    modification_details2: string,
    modification_item3: string,
    modification_details3: string,
    remake_url: string,
  }): Promise<AjaxResponseType> {
    return ajaxPost(`/karaoke_modification/ajax_execute_karaoke_modification/${karaokeOrderId}`, formData, {}, true);
  },
  executeKaraokeRegistrationStart(karaokeOrderId: number): Promise<AjaxResponseType> {
    return ajaxPost(`/karaoke_modification/ajax_execute_karaoke_registration_start/${karaokeOrderId}`, {}, {}, true);
  },
  executeKaraokeRegistrationCancel(karaokeOrderId: number): Promise<AjaxResponseType> {
    return ajaxPost(`/karaoke_modification/ajax_execute_karaoke_registration_cancel/${karaokeOrderId}`, {}, {}, true);
  },
  executeKaraokeDistributionCancel(karaokeOrderId: number): Promise<AjaxResponseType> {
    return ajaxPost(`/karaoke_modification/ajax_execute_karaoke_distribution_cancel/${karaokeOrderId}`, {}, {}, true);
  },
};

export const KaraokeModificationClientContext = React.createContext(defaultKaraokeModificationClient);

